// Import Libraries
import React, { useEffect, useState, useContext } from 'react';

// Get Context
import { UserContext } from '../../context/User';
import SessionContext from '../../context/Session';

// Build Component
function FreeTrialActivated() {
  const { user } = useContext(UserContext);
  const { isMobile } = useContext(SessionContext);
  const [warningClosed, setWarningClosed] = useState(false);
  const [isEdu, setIsEdu] = useState(false);

  const goToUpload = async () => {
    window.location.href = `/app/newProject/1`;
  };

  useEffect(() => {
    if (user && user.email && user.email.includes('.edu')) {
      setIsEdu(true);
    }
  }, [user]);

  return (
    <>
      {isMobile && !warningClosed ? (
        <>
          <div className="ReactModal__Overlay"></div>
          <div className="modal modalMobile centered">
            <img
              src="/icons/WarningIcon_Purple.png"
              className="Padded"
              alt="Thumbs Up Icon"
              style={{ width: '10%' }}
            />
            <div className="bold Padded purpleText">Switch to desktop</div>
            <div className="Padded">
              Not yet optimized for mobile. We highly recommend you switch to a tablet or computer.
            </div>
            <div className="Padded">
              <button className="buttonGray fullWidth" onClick={() => setWarningClosed(true)}>
                Continue on Mobile
              </button>
            </div>
          </div>
        </>
      ) : null}
      <div className="fullWidthContainer">
        <div className="OnePortionFlex Padded"></div>
        <div className="FivePortionFlex Padded">
          {isEdu ? (
            <>
              <div className="centered">
                <div className="bold large Padded">
                  <img
                    src="/icons/ThumbsUpIcon.png"
                    className="Padded"
                    alt="Thumbs Up Icon"
                    style={{ width: '30%' }}
                  />
                </div>
                <div className="bold large Padded purpleText">Congratulations!</div>
                <div className="Padded subHeader">
                  You have successfully activated your free month of pro.
                </div>
              </div>
              <div style={{ paddingTop: '30px' }}>
                <div className="Padded">Your free trial includes AI-generated shotlists:</div>
                <ul style={{ textAlign: 'left', paddingBottom: '20px' }}>
                  <li style={{ marginBottom: '10px' }}>For 3 feature length projects</li>
                  <li style={{ marginBottom: '10px' }}>
                    Free use of most of our pro features for those projects.
                  </li>
                </ul>
                <button className="buttonClone fullWidth" onClick={() => goToUpload()}>
                  Get Started
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="centered">
                <div className="bold large Padded">
                  <img
                    src="/icons/ThumbsUpIcon.png"
                    className="Padded"
                    alt="Thumbs Up Icon"
                    style={{ width: '30%' }}
                  />
                </div>
                <div className="bold large Padded purpleText">Start building your shot list.</div>
                <div className="Padded subHeader">
                  Dive in! You get the full ShotKraft experience free for your first 5 scenes.
                </div>
              </div>
              <div style={{ paddingTop: '30px' }}>
                <ul style={{ textAlign: 'left', paddingBottom: '20px' }}>
                  <li style={{ marginBottom: '10px' }}>
                    AI-generated shot lists, ready in seconds
                  </li>
                  <li style={{ marginBottom: '10px' }}>
                    Pro tools: exports, filters, and real-time collaboration
                  </li>
                  <li style={{ marginBottom: '10px' }}>Shareable links to send to your crew</li>
                </ul>
                <button className="buttonClone fullWidth" onClick={() => goToUpload()}>
                  Create My First Shot List →
                </button>
              </div>
            </>
          )}
        </div>
        <div className="OnePortionFlex Padded"></div>
      </div>
    </>
  );
}

export default FreeTrialActivated;
